module.exports = __webpack_public_path__ + "img/1439744004.2cba4b37.jpg";